// app/books/book.service.ts
import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, ResourceRequestMethod, IResourceMethod } from '@ngx-resource/core';

import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';

interface Form {
    data: any;
}


@Injectable()
@ResourceParams({
    url: `${environment.url.api}`
})
export class FormService extends RestClient {

    @ResourceAction({
        path: 'api/form/startInstance/{:id}',
        method: ResourceRequestMethod.Get
    })
    startInstance: IResourceMethod<{ id: any }, Form>;

    @ResourceAction({
      path: '/admin/report/prepareDownload/{:id}',
      method: ResourceRequestMethod.Post
    })
    downloadReport: IResourceMethod<{ id: any }, Form>;

    @ResourceAction({
        path: 'api/form/startTrackerInstance/{:id}',
        method: ResourceRequestMethod.Get
    })
    startTrackerInstance: IResourceMethod<{ id: any }, Form>;

    @ResourceAction({
        path: '/api/forms/save/next',
        method: ResourceRequestMethod.Post
    })
    nextPage: IResourceMethod<Form, Form>;

    @ResourceAction({
        path: '/api/forms/save/prev',
        method: ResourceRequestMethod.Post
    })
    prevPage: IResourceMethod<Form, Form>;

    @ResourceAction({
        path: '/api/forms/finish',
        method: ResourceRequestMethod.Post
    })
    finish: IResourceMethod<Form, Form>;

    @ResourceAction({
        path: '/api/forms/generatePDF/{:id}',
        method: ResourceRequestMethod.Get
    })
    generatePDFUrl: IResourceMethod<number, string>;

    @ResourceAction({
        path: '/api/forms/updateConditionals/{:id}',
        method: ResourceRequestMethod.Post
    })
    updateConditionals: IResourceMethod<{ form: Form, id: any }, Form>;

    @ResourceAction({
        path: '/api/item/audio/{:fileName}',
        method: ResourceRequestMethod.Get
    })
    itemAudio: IResourceMethod<{ fileName: string }, any>;
}
